import { mergeArrays, replaceItem } from '../../helpers/helpers';
import * as type from '../actions/types';

const initialState = {
  errors: [],
  fetching: false,
  posting: false,
  success: false,
  data: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_FOOD_ITEM_PENDING:
      return {
        ...state,
        ...initialState,
        loading: true,
        success: false,
        errors: [],
      };
    case type.FETCH_FOOD_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        errors: [],
        data: replaceItem(state.data, action.payload, 'id', true),
      };
    case type.FETCH_FOOD_ITEM_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        errors: action.payload,
      };
    case type.FETCH_FOOD_ITEMS_PENDING:
      return {
        ...state,
        ...initialState,
        fetching: true,
        success: false,
        errors: [],
      };
    case type.FETCH_FOOD_ITEMS_SUCCESS:
      return {
        ...state,
        fetching: false,
        success: true,
        errors: [],
        data: mergeArrays(state.data, action.payload?.data, 'id', true),
      };
    case type.FETCH_FOOD_ITEMS_FAILURE:
      return {
        ...state,
        fetching: false,
        success: false,
        errors: action.payload,
      };
    case type.CREATE_FOOD_ITEM_PENDING:
      return {
        ...state,
        posting: true,
        success: false,
        errors: [],
      };
    case type.CREATE_FOOD_ITEM_SUCCESS:
      const newItem = action?.payload?.data;

      console.log('new foodItem', newItem);

      return {
        ...state,
        posting: false,
        success: true,
        errors: [],
        data: replaceItem(state.data, newItem, 'id', true),
      };
    case type.CREATE_FOOD_ITEM_FAILURE:
      return {
        ...state,
        posting: false,
        success: false,
        errors: action.payload,
      };
    case type.UPDATE_FOOD_ITEM_PENDING:
      return {
        ...state,
        posting: true,
        success: false,
        errors: [],
      };
    case type.UPDATE_FOOD_ITEM_SUCCESS:
      console.log('UPDATE_FOOD_ITEM_SUCCESS', action);
      const updatedItem = action?.payload;
      console.log('updated foodItem', updatedItem);

      return {
        ...state,
        posting: false,
        success: true,
        errors: [],
        data: replaceItem(state.data, updatedItem, 'id', true),
      };
    case type.UPDATE_FOOD_ITEM_FAILURE:
      return {
        ...state,
        posting: false,
        success: false,
        errors: action.payload,
      };
    default:
      return state;
  }
};
